export class AttachmentType {
  
  constructor(typeName) {
    this.typeName = typeName;
  }
  
  getTypeName() {
    return this.typeName;
  }

  mdIcon() {
    return {
      'picture': 'local_see',
      'video': 'videocam',
      'bzcRichLink': 'insert_link',
      'file': 'attach_file'
    }[this.getTypeName()];
  }

  initScope($scope, MediasFactory, AlertingFactory, companyId, siteId) {
    // Nothing special by default
  }

  addAttachment($translate, $uibModal, editorElement, attachements, companyId, siteId) {
    throw 'not implemented';
  }

  static enabledTypes(options) {
    return ['picture', 'video', 'bzcRichLink', 'file']
      .filter(typeName => options && options[typeName + 'Enabled'])
      .map(typeName => AttachmentType.fromTypeName(typeName));
  }

  static fromAttachment(attachment) {
    return AttachmentType.fromTypeName(attachment.type);
  }

  static fromTypeName(typeName) {
    switch (typeName) {
      case 'picture':
      case 'video':
      case 'file':
        return new FileAttachementType(typeName);
      case 'bzcRichLink':
        return new BzcRichLinkAttachementType(typeName);
      default:
        throw 'unknown attachement type: ' + typeName;
    }
  }
}


class FileAttachementType extends AttachmentType {

  constructor(typeName) {
    super(typeName);
  }

  initScope($scope, MediasFactory, AlertingFactory, companyId, siteId) {
    $scope.$watch('filenames.' + super.getTypeName(), file => {
      if (file) {
        $scope.uploadingFileAttachment = true;
        $scope.uploadProgress = 0;
        let mediaType = super.getTypeName();
        if (mediaType === 'picture') {
          mediaType = 'image'; // apologies for using 'picture' instead of 'image' in editor2
        }
        MediasFactory.upload2(companyId, siteId, mediaType, file, 
          response => {
            let attachmentValue;
            if (mediaType === 'file') {
              attachmentValue = {
                fileName: file.name
              };  
              attachmentValue[super.getTypeName() + 'Id'] = response.data.file_id;
            } else {
              attachmentValue = {};
              attachmentValue[super.getTypeName() + 'Id'] = response.data.media_id;  
            }
            this.attachments.push({
              'type': super.getTypeName(),
              'value': attachmentValue
            });
            $scope.uploadingFileAttachment = false;
          },
          response => {
            $scope.uploadingFileAttachment = false;
            AlertingFactory.error(response && response.data && response.data.error ? response.data.error : 'common/http_error');
          },
          percent => $scope.uploadProgress = percent);
      }
    });
  }

  addAttachment($translate, $uibModal, editorElement, attachments, companyId, siteId) {
    this.attachments = attachments; // needed by the callback above when upload succeeds
    editorElement.find('#' + super.getTypeName() + '-upload').click();
  }

}


class BzcRichLinkAttachementType extends AttachmentType {

  constructor(typeName) {
    super(typeName);
  }

  addAttachment($translate, $uibModal, editorElement, attachments, companyId, siteId) {

    $uibModal.open({
      animation: true,
      template:  require('../../parameters/quick-replies/joint-diagram/shared/editTemplateElement.modal.html'),
      controller: 'editTemplateElementController',
        resolve: {
          companyId: () => companyId,
          siteId: () => siteId,
          templateType: () => 'editor2-' + this.getTypeName(),
          element: () => ({
            'title': 'titre',
            'url': 'https://'
          }),
          modalTitle: () => $translate.instant('editor2/attachments/bzc_rich_link_popin_title'),
          showRemoveButton: () => false,
          showCompactCheckbox: () => false
        }
    }).result.then(result => {  
      if (result.type === 'edit') {
        attachments.push({
          'type': super.getTypeName(),
          'value': result.element
        });
      }
    });
  }

}
